import { createActionType, createAction, createApiCallAction } from '@ers/helpers';

const prefix = 'Home';
export const ActionTypes = {
    resetApplications: createActionType('resetApplications')(prefix),
    fetchApplications: createActionType('fetchApplications')(prefix),
    fetchApplicationsCompleted: createActionType('fetchApplicationsCompleted')(prefix),
    saveScrollPosition: createActionType('saveScrollPosition')(prefix),
    fetchFile: createActionType('fetchFile')(prefix),
    fetchFileCompleted: createActionType('fetchFileCompleted')(prefix),
    fetchFileError: createActionType('fetchFileError')(prefix),
    fetchEditUrl: createActionType('fetchEditUrl')(prefix),
    fetchEditUrlCompleted: createActionType('fetchEditUrlCompleted')(prefix),
    archive: createActionType('archive')(prefix),
    archiveUpdated: createActionType('archiveUpdated')(prefix),
    fetchArchivedCount: createActionType('fetchArchivedCount')(prefix),
    fetchArchivedCountCompleted: createActionType('fetchArchivedCountCompleted')(prefix),
};

export const resetApplications = createAction(ActionTypes.resetApplications);
export const fetchApplications = (archived) => () => createApiCallAction(ActionTypes.fetchApplications)({ payload: { archived } });
export const fetchArchivedCount = () => createApiCallAction(ActionTypes.fetchArchivedCount)({ payload: { } });
export const fetchArchivedCountCompleted = (count) => createAction(ActionTypes.fetchArchivedCountCompleted)({ payload: { count } });
export const fetchApplicationsCompleted = createAction(ActionTypes.fetchApplicationsCompleted);
export const saveScrollPosition = (scrollPosition, archived) => createAction(ActionTypes.saveScrollPosition)({ payload: { scrollPosition, archived } });
export const fetchFile = (key) => createApiCallAction(ActionTypes.fetchFile)({ payload: { key } });
export const fetchFileCompleted = (applicationId, fileId, file) => createAction(ActionTypes.fetchFileCompleted)({ payload: { applicationId, fileId, file } });
export const fetchFileError = (key) => createAction(ActionTypes.fetchFileError)({ payload: { key } });
export const fetchEditUrl = (key) => createApiCallAction(ActionTypes.fetchEditUrl)({ payload: { key } });

export const fetchEditUrlCompleted = (applicationId, editUrl) => createAction(ActionTypes.fetchEditUrlCompleted)({ payload: { applicationId, editUrl } });

export const archive = (applicationId, archived) => createAction(ActionTypes.archive)({ payload: { applicationId, archived } });
export const archiveUpdated = () => createAction(ActionTypes.archiveUpdated)({ payload: {} });